import { createAsyncThunk } from "@reduxjs/toolkit";
import coreAPIs from "services/api/core";

export const getTransformVideos = createAsyncThunk("core/transformVideos/getTransformVideos", async (payload) => {
  try {
    const response = await coreAPIs.getTransformVideos(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
